<template>
  <v-layout align-center justify-center>

    <v-flex xs12 sm8 md4>
      <v-card class="elevation-12">
        <div class="header-box">
          <v-img contain max-height="75" min-height="50" src="../../../assets/de-logo_no_line.png" alt="Data Energy Metering and Billing Portal"></v-img>
        </div>
        <h2 class="auth-heading"><slot name="header"></slot></h2>
        <v-card-text>
          <slot></slot>
        </v-card-text>

        <v-card-actions>

          <slot name="main-action"></slot>

        </v-card-actions>

        <v-divider class="mt-2 mx-4" />

        <v-card-actions class="px-4 text-caption grey--text">
          <div class="privacy-link">
            <slot name="footer-link"></slot>
          </div>
        </v-card-actions>
      </v-card>
    </v-flex>
  </v-layout>

</template>

<script>
export default {
  name: "AuthWrapper"
}
</script>

<style lang="scss" scoped>
.header-box {
  padding: 20px 0px 10px;
}

.auth-heading {
  text-transform: none !important;
  background-color: #5d3791;
  color: white !important;
  padding: 15px 10px;
}

.privacy-link {
  margin: auto;
  width: 100%;
  text-align: center;
}
</style>
